import { writable } from 'svelte/store';
function createPersistentStore(key, startValue) {
    const storedValue = localStorage.getItem(key);
    const initialValue = storedValue ? JSON.parse(storedValue) : startValue;
    const store = writable(initialValue);
    store.subscribe(value => {
        localStorage.setItem(key, JSON.stringify(value));
    });
    return store;
}
export const uiStore = createPersistentStore('uiSettings', {
    sidebarToggle: false,
    darkMode: false,
});
